<template>
  <div class="logos">
    <a href="https://dornsife.usc.edu/bridge-institute/" target="_blank">
      <img src="./img/Bridge-darkMode.png" alt="USC Bridge Institute" title="USC Bridge Institute" />
    </a>
  </div>
</template>

<style scoped>
.logos {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
img {
  height: auto;
  width: auto;
  max-height: clamp(20px, 8vw, 80px);
}
</style>
